/**
 * The benefit period shown on a collapsed OneAmerica Asset Care card.
 *
 * An Asset Care quote is sold on two periods, acceleration (AOB) and continuation
 * (COB), and a client can be offered the same premium under several of each. The
 * collapsed card showed neither, so a 2-year and a 3-year AOB quote looked like
 * the same card twice until one was opened. The wording matches the expanded
 * details ("3 Years AOB/2 Years COB"), so the two never disagree.
 *
 * Returns null for any other product, and when the quote carries no AOB period.
 */
import { isOneAmericaAssetCare } from '@shared';

interface BenefitPeriodQuote {
  fundingPolicyType?: number | null;
  aobDuration?: string | null;
  cobDuration?: string | null;
}

export function getAssetCareBenefitPeriodLabel(quote: BenefitPeriodQuote): string | null {
  if (quote.fundingPolicyType == null || !isOneAmericaAssetCare(quote.fundingPolicyType)) {
    return null;
  }

  const aob = quote.aobDuration?.trim();
  if (!aob) return null;

  const cob = quote.cobDuration?.trim();
  const hasCob = Boolean(cob) && !/^(n\/a|none)$/i.test(cob as string);
  return hasCob ? `${aob} AOB / ${cob} COB` : `${aob} AOB`;
}
